import * as React from "react";
const SvgStop = (props) => /* @__PURE__ */ React.createElement("svg", { "data-testid": "geist-icon", height: 16, strokeLinejoin: "round", viewBox: "0 0 16 16", width: 16, style: {
  color: "currentcolor"
}, ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 2.5C3.39543 2.5 2.5 3.39543 2.5 4.5V11.5C2.5 12.6046 3.39543 13.5 4.5 13.5H11.5C12.6046 13.5 13.5 12.6046 13.5 11.5V4.5C13.5 3.39543 12.6046 2.5 11.5 2.5H4.5Z", fill: "currentColor" }));
export default SvgStop;
